import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { Clinic } from "src/app/shared/models/clinic.model";
import { Doctor } from "src/app/shared/models/common";
import {
  DrProfile,
  DrProfileSearchParams,
} from "src/app/shared/models/order.model";
import { clinicList, doctorList } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";
import { BroshService } from "src/app/shared/services/brosh.service";

@Component({
  selector: "create-dr-profile",
  templateUrl: "./create-dr-profile.component.html",
  styleUrls: ["./create-dr-profile.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
  ],
  standalone: true,
})
export class CreateDrProfileComponent {
  @Output() onClose = new EventEmitter<DrProfile>();

  clinic: Clinic;
  doctor: Doctor;
  saving: boolean;

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  get doctorList(): Doctor[] {
    return this.store.selectSignal(doctorList)();
  }

  constructor(
    private readonly store: Store,
    private broshService: BroshService
  ) { }

  save() {
    this.saving = true;
    this.broshService
      .createDrProfile(this.clinic?.id, this.doctor?.id)
      .subscribe(
        (profileId) => {
          let sp = new DrProfileSearchParams();
          sp.profileId = profileId;
          this.broshService.getDrProfiles(sp, false).subscribe(
            (data) => {
              this.saving = false;
              this.onClose.emit(data[0]);
            },
            () => (this.saving = false)
          );
        },
        () => (this.saving = false)
      );
  }

  saveEnabled() {
    return this.clinic != null || this.doctor != null;
  }

  closePanel() {
    this.onClose.emit();
  }
}
